<template>
  <div class="root">
    <div class="header-box add-bg">
      <div class="c-header">
        <div class="header-logo">
          <a href="/">
            <img src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <h2>职位列表</h2>
        <p>简历发送至:<span>jrzp@bajiegroup.com</span></p>
        <div class="search-input">
          <input type="text" v-model="keyWord" placeholder="请输入关键词搜索更多职位，例如“工程师”">
          <span @click="searchHandler">搜索</span>
        </div>
        <div class="selects">
          <el-select v-model="workPlace" placeholder="请选择工作地点" style="width:48%">
            <el-option v-for="item in workPlaceList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span style="width:4%;display:inline-block"></span>
          <el-select v-model="position" placeholder="请选择职位类型" style="width:48%">
            <el-option v-for="item in positionList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="job-list">
        <ul v-if="jobList.length > 0">
          <li v-for="(item,index) in jobList" :key="index" @click="goDetail(item.positionName)">
            <p class="job-item">
              <span>{{item.positionName}}</span>
              <i>发布时间：{{item.releaseDate}}</i>
            </p>
          </li>
        </ul>
        <div v-else class="no-job">暂无招聘信息</div>
        <div style="text-align:center;padding-top:20px" v-if="totalRecord >0 && jobList.length > 0">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="pageIndex" :page-sizes="[10, 20, 30]" :page-size="pageSize" layout="prev, pager, next"
            :total="totalRecord">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import job from "@/global/js/staticData/job";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "join-us",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 1,
      keyWord: "",
      workPlace: "",
      position: "",
      workPlaceList: [{ label: "重庆", value: "重庆" }],
      positionList: [
        { label: "技术类", value: "技术类" },
        { label: "风控类", value: "风控类" },
        { label: "市场类", value: "市场类" },
        { label: "产品类", value: "产品类" },
      ],
      jobList: [], // 模拟职位招聘信息
      pageIndex: 1,
      pageSize: 10,
      totalRecord: "",
      originalJobList: [],
    };
  },
  mounted() {
    this.$bus.$emit("ready");
    console.log(job);
    this.totalRecord = job.jobList.length;
    this.originalJobList = job.jobList;
    this.getCurrentPage(1);
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.getCurrentPage(this.pageIndex);
    },
    getCurrentPage(startIndex) {
      this.jobList = this.originalJobList.slice((startIndex - 1) * this.pageSize, (startIndex - 1) * this.pageSize + this.pageSize);
      this.totalRecord = this.originalJobList.length;
    },
    searchHandler() {
      this.originalJobList = job.jobList;
      if (this.keyWord === "" && this.workPlace === "" && this.position === "") {
        this.originalJobList = job.jobList;
      }
      if (this.keyWord !== "") {
        this.originalJobList = this.originalJobList.filter((item) => {
          if (item.positionName.indexOf(this.keyWord) > -1) {
            return item;
          }
        });
      }
      if (this.workPlace !== "") {
        this.originalJobList = this.originalJobList.filter((item) => {
          if (item.workPlace.indexOf(this.workPlace) > -1) {
            return item;
          }
        });
      }
      if (this.position !== "") {
        this.originalJobList = this.originalJobList.filter((item) => {
          if (item.positionType.indexOf(this.position) > -1) {
            return item;
          }
        });
      }
      this.getCurrentPage(this.pageIndex);
      this.keyWord = "";
      this.position = "";
      this.workPlace = "";
      console.log(this.originalJobList);
    },
    goDetail(name) {
      console.log(name);
      this.$router.push({
        path: "/joinUsDetail",
        query: {
          name: name,
        },
      });
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>
<style lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.el-pager li.active {
  color: #ff6900;
  border: 1px solid #ff6900;
  border-radius: 20px;
}
.el-pager li:hover {
  color: #ff6900;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #ff6900;
}
.el-select .el-input__inner:focus {
  border-color: #ff6900;
}
.el-select-dropdown__item.selected {
  color: #ff6900;
}
.el-pager li {
  min-width: 28.5px;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  &:hover {
    color: #ff6900;
  }
}
</style>
<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.root {
  background-color: transparent;
}
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  background-color: #fff;
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
        &.active {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
      }
    }
  }
}
.content {
  width: 1200px;
  height: auto;
  padding-top: 144px;
  margin: 0 auto;
  padding-bottom: 141px;
  .search {
    width: 1200px;
    height: 270px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px 50px;
    margin-bottom: 10px;
    h2 {
      font-weight: normal;
      font-size: 22px;
      color: #000000;
      height: 40px;
      line-height: 40px;
    }
    p {
      font-size: 22px;
      height: 42px;
      line-height: 42px;
      color: #000000;
      text-align: center;
      span {
        color: #ff6900;
      }
    }
    .search-input {
      width: 1100px;
      height: 46px;
      padding: 12px 0;
      input {
        width: 974px;
        box-sizing: border-box;
        line-height: 44px;
        height: 46px;
        border: 1px solid #dcdfe6;
        outline: none;
        padding-left: 15px;
        &:focus {
          border: 1px solid #ff6900;
        }
        // &:hover{
        //   border-color: #c0c4cc;
        // }
      }
      span {
        float: right;
        width: 126px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        background-color: #ff4300;
        cursor: pointer;
        &:hover {
          background-color: #ff6900;
        }
      }
    }
    .selects {
      width: 1100px;
      height: 46px;
      padding: 12px 0;
    }
  }
  .job-list {
    width: 1200px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px 0px;
    ul {
      li {
        padding: 0 50px;
        box-sizing: border-box;
        font-size: 18px;
        cursor: pointer;
        &:hover {
          background-color: #f9f9fa;
        }
        .job-item {
          width: 100%;
          height: 70px;
          line-height: 70px;
          border-bottom: 1px solid #ededed;
          span {
            float: left;
            color: #000000;
          }
          i {
            float: right;
            color: #2f2b27;
            font-style: normal;
          }
        }
      }
    }
    .no-job {
      width: 100%;
      height: 200px;
      line-height: 200px;
      text-align: center;
      font-size: 30px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// joinUs.vue?b3857462